import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import AnimatedComponent from '../../components/Animation/AnimatedComponent';
import Loader from '../../components/Loader';

import { useDispatch, useSelector } from 'react-redux';
import {
  getDashboardDetails,
  getDashboardDetailsById,
} from '../../api/DashboardAPI';
import { ROLES } from '../../common/constants';
import { PageBody } from '../../components/SiteWrapper';
import ControlAdminCount from './ControlAdminCount';
import ControlAdminDashboard from './ControlAdminDashboard';
import CountWidget from './CountWidget';
import InProgressExam from './InProgressExam';
import SuperAdminDashboard from './SuperAdminDashboard';
import { UpcomingExam } from './UpcomingExam';
import ImpNotification from './ImpNotification';

const Dashboard = ({ rrb_id = null, name = 'Dashboard' }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const dashboardName = searchParams.get('name');
  const manual = searchParams.get('man');

  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const isSuperadmin = authSelector?.role?.slug === ROLES.SUPERADMIN;
  const isControladmin = authSelector?.role?.slug === ROLES.CONTROL_ADMIN;
  const navigate = useNavigate();

  const [dashboard, setDashboard] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const sidebarCounterSelector = useSelector(
    (state) => state.rrb.sidebarCounterReducer
  );

  const fetchDashboardData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = id
        ? await getDashboardDetailsById(id)
        : await getDashboardDetails();
      // const res = await getDashboardDetails();
      setDashboard(res.data);
    } catch (error) {
      console.log('🚀 ~ fetchDashboardData ~ error:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (authSelector.role.slug === ROLES.CENTER_COORDINATOR) {
      navigate('/exams');
    } else {
      fetchDashboardData();
    }
  }, [sidebarCounterSelector.dashboardUpdate]);

  return (
    <AnimatedComponent as={PageBody}>
      {dashboard?.unreadNotifications?.length > 0 && (
        <>
          <div className='page-header mt-0'>
            <h2 className='page-title mb-2'>Important Notifications</h2>
          </div>
          <ImpNotification data={dashboard?.unreadNotifications} />
        </>
      )}
      <div className='page-header mt-0'>
        <h2 className='page-title mb-2'>{dashboardName || 'Dashboard'}</h2>
      </div>
      {isLoading && <Loader />}
      <Row className='g-3'>
        {isControladmin ? (
          <ControlAdminCount data={dashboard} />
        ) : (
          <CountWidget data={dashboard} isSuperadmin={isSuperadmin} />
        )}

        {!manual && isSuperadmin ? (
          <SuperAdminDashboard
            data={dashboard}
            setDashboard={setDashboard}
            setParentLoading={setIsLoading}
            parentLoading={isLoading}
          />
        ) : isControladmin ? (
          <ControlAdminDashboard />
        ) : (
          <Fragment>
            <InProgressExam
              data={dashboard?.runningExams}
              rrb_id={rrb_id}
              setDashboard={setDashboard}
              onGoingExamsStats={dashboard?.onGoingExamsStats}
            />
            <UpcomingExam data={dashboard?.upcomingExams} />
            {/* {(!isSuperadmin && dashboard?.runningExams?.length === 0 && dashboard?.upcomingExams?.length === 0) && <Exams isDashboard={true} />} */}
          </Fragment>
        )}
      </Row>
    </AnimatedComponent>
  );
};

export default Dashboard;
